<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-form :model="searchForm" :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-input size="small" clearable v-model="searchForm.searchName" placeholder="部门名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" icon="el-icon-search" @click="filterMethod">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-transfer
      v-model="selectFrameValue"
      @left-check-change="leftchage"
      :data="data"
      @change="onselect"
      :titles="['部门', '已选择']"
    >
      <el-button class="transfer-footer" slot="left-footer" @click="privousLevel" size="small">上一级</el-button>
      <el-button class="transfer-footer" slot="left-footer" @click="nextLevel" size="small">下一级</el-button>
      <el-button class="transfer-footer" slot="right-footer" @click="clearSelect" size="small">清除所选</el-button>
    </el-transfer>
  </div>
</template>
<script>
import {
  GetFrameByParentId,
  GetFrameById,
  GetFrameListByPid,
  GetFrameByName
} from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { isInArray } from "../../until/Common";
export default {
  data() {
    return {
      data: [],
      selectFrameValue: [],
      leftchecked: [],
      selectedData: [],
      searchForm: { searchName: "" }
    };
  },
  created() {
    this.InitData();
  },
  methods: {
    InitData: function() {
      GetFrameByParentId("09308a98-76a5-4fd8-b810-ddd76d37fe4b").then(res => {
        if (res) {
          res.forEach(element => {
            var d = { key: element.Id, label: element.ClassName };
            this.data.push(d);
          });
        }
      });
    },
    filterMethod: function() {
      this.data = this.selectedData;
      GetFrameByName(this.searchForm.searchName).then(res => {
        if (res) {
          res.forEach(element => {
            var d = { key: element.Id, label: element.ClassName };
            if (isInArray(this.data, d)) {
              this.data.push(d);
            }
          });
        }
      });
    },
    reset: function() {
      this.data = [];
      this.searchForm.searchName = "";
      this.InitData();
    },
    nextLevel: function() {
      if (this.leftchecked.length > 0) {
        if (this.leftchecked.length > 1) {
          this.$message({
            message: "只能选择一项",
            type: "warning",
            center: true
          });
        } else {
          GetFrameByParentId(this.leftchecked[0]).then(res => {
            if (res.length > 0) {
              this.data = [];
              res.forEach(element => {
                this.data.push({ key: element.Id, label: element.ClassName });
              });
            } else {
              this.$message({
                message: "没有下级部门或未选择项",
                type: "warning",
                center: true
              });
            }
          });
        }
      } else {
        this.$message({
          message: "请选择一项",
          type: "warning",
          center: true
        });
      }
    },
    onselect: function(keys) {
      if (keys.length > 0) var result = [];
      keys.forEach(element => {
        var f = this.data.filter(p => p.key == element);
        if (f.length > 0) {
          result.push(f[0]);
        }
      });
      this.selectedData = result;
      this.$emit("ConfirmeValue", result);
    },
    privousLevel: function() {
      GetFrameById(this.data[0].key).then(res => {
        if (res) {
          GetFrameById(res[0].ParentId).then(pres => {
            if (pres) {
              GetFrameByParentId(pres[0].ParentId).then(lres => {
                if (lres) {
                  this.data = [];
                  lres.forEach(element => {
                    this.data.push({
                      key: element.Id,
                      label: element.ClassName
                    });
                  });
                }
              });
            }
          });
        }
      });
    },
    clearSelect: function() {
      this.selectFrameValue = [];
    },
    leftchage: function(keys) {
      this.leftchecked = keys;
    }
  }
};
</script>
<style >
.el-transfer-panel {
  text-align: left;
}
</style>